'use client';
import { useEffect, useState } from 'react';

import Typography from '@/components/shared/typography/typography.component';
import SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import POPULAR_MAKES from '../popular-makes';
import {
    EInspectionType,
    Make,
    EInspectionTypeSelectionVariants,
} from '@/types';
import {
    IFormatedData_SELL,
    useSellCarNew,
    useTranslation,
    useWindowDimensions,
} from '@/hook';
import { useRouter } from 'next/navigation';
import styles from './styles.module.scss';
import Image from 'next/image';
import {
    InspectionButtonMobile,
    SylndrHubLocationButtonMobile,
    SylndrHubLocation,
} from '@/components/sell-car-form';
import { BlueHomeIcon, SylndrS } from '../../../../../public/Images';
import {
    STEPPER_STEPS_FULL_DATA_DESKTOP_WAREHOUSE_VARIANT,
    SELL_CAR_FORM_DATA_FULL_WAREHOUSE_VARIANT,
    SELL_CAR_FORM_DATA_FULL_HOME_VARIANT,
    STEPPER_STEPS_FULL_DATA_DESKTOP_HOME_VARIANT,
} from '@/hook/acquisition/sell-car-form-data-stepper-variations';

const SelectMakeCard = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const { width } = useWindowDimensions();

    const [selectedMake, setSelectedMake] = useState<Make | undefined>();
    const [selectedInspectionType, setSelectedInspectionType] =
        useState<EInspectionType>();

    const {
        setChoosenData,
        intializeSellCar,
        getExperimentFlag,
        triggerDefaultInspectionEvent,
        getPath,
        selectWarehouseInspection,
    } = useSellCarNew();
    const router = useRouter();
    const experimentFlag = getExperimentFlag();
    const [openDirectionModal, setOpenDirectionModal] = useState(false);

    const points = [
        { id: 'point1', value: t('mobileFormBannerCardPoint1') },
        { id: 'point3', value: t('mobileFormBannerCardPoint3') },
    ];

    const inspectionTypeSelected = (id: string) => {
        setSelectedInspectionType(id as EInspectionType);
        const inspectionObj: IFormatedData_SELL = {
            nameEn: t(id),
            nameAr: t(id),
            icon: '',
            inShoppingList: true,
            id: id,
            selected: true,
        };
        setChoosenData('inspectionType', inspectionObj);
    };
    const toggleDirectionModal = () => {
        setOpenDirectionModal(!openDirectionModal);
    };

    const popularMakeClicked = () => {
        if (selectedMake?.id === 'All Makes') {
            router.push(`/${lang}/sell-form`);
            return;
        }
        if (selectedMake) {
            const formDataObj: IFormatedData_SELL = {
                selected: true,
                inShoppingList: true,
                icon: selectedMake?.image,
                nameAr: selectedMake?.arName,
                nameEn: selectedMake?.enName,
                id: selectedMake?.id,
            };
            setChoosenData('make', formDataObj);
            router.push(`/${lang}/sell-form#model`);
        }
    };

    const makeItemClicked = (make: Make) => {
        if (getExperimentFlag()) {
            const inspectionObj: IFormatedData_SELL = {
                nameEn: t(selectedInspectionType),
                nameAr: t(selectedInspectionType),
                icon: '',
                inShoppingList: true,
                id: selectedInspectionType,
                selected: true,
            };
            setChoosenData('inspectionType', inspectionObj);
        }
        setSelectedMake(make);
    };

    const triggerDefault = (value: EInspectionType) => {
        const inspectionObj: IFormatedData_SELL = {
            nameEn: t(value),
            nameAr: t(value),
            icon: '',
            inShoppingList: getPath() === 'path1',
            id: value,
            selected: true,
        };
        triggerDefaultInspectionEvent(inspectionObj);
    };
    useEffect(() => {
        if (width > 1100) return;
        if (
            selectWarehouseInspection ===
                EInspectionTypeSelectionVariants.ORIGINAL ||
            selectWarehouseInspection === EInspectionTypeSelectionVariants.HOME
        ) {
            intializeSellCar(
                STEPPER_STEPS_FULL_DATA_DESKTOP_HOME_VARIANT,
                SELL_CAR_FORM_DATA_FULL_HOME_VARIANT
            );
            setSelectedInspectionType(EInspectionType.HOME);
            triggerDefault(EInspectionType.HOME);
        } else {
            if (
                selectWarehouseInspection ===
                EInspectionTypeSelectionVariants.WAREHOUSE
            ) {
                intializeSellCar(
                    STEPPER_STEPS_FULL_DATA_DESKTOP_WAREHOUSE_VARIANT,
                    SELL_CAR_FORM_DATA_FULL_WAREHOUSE_VARIANT,
                    true
                );
                setSelectedInspectionType(EInspectionType.WAREHOUSE);
                triggerDefault(EInspectionType.WAREHOUSE);
            }
        }
    }, [selectWarehouseInspection]);

    return (
        <div className={styles.card_container}>
            {/* <img style={{ marginTop: -40 }} src={BannerCar} alt="Banner Car"></img> */}
            <section className={styles.main_conatainer}>
                {!experimentFlag && (
                    <section className={styles.items_flex_container}>
                        <Typography
                            variant="h6Bold"
                            color="#002d5d"
                            style={{
                                textAlign: 'start',
                                paddingTop: '5%',
                                paddingBottom: '5%',
                            }}
                        >
                            {t('mobileFormBannerCardHeader')}
                        </Typography>
                        <div style={{ textAlign: 'left', paddingBottom: '1%' }}>
                            <section style={{ display: 'flex', gap: '4%' }}>
                                {points.map(point => (
                                    <div
                                        style={{ display: 'flex', gap: '4px' }}
                                        key={point.id}
                                    >
                                        <CheckCircleIcon color="primary" />
                                        <Typography
                                            className={styles.point_text}
                                            variant="body1"
                                        >
                                            {point.value}
                                        </Typography>
                                    </div>
                                ))}
                            </section>
                        </div>
                    </section>
                )}
                {experimentFlag && (
                    <section className={styles.items_flex_container}>
                        <Typography
                            variant="body1Medium"
                            className={styles.select_make}
                        >
                            {t('selectYourInspectionType')}
                        </Typography>

                        <div className={styles.inspection_buttons_container}>
                            <InspectionButtonMobile
                                id={EInspectionType.HOME}
                                header={t('InspectionAtHomeMobile')}
                                subHeader={t('24HoursOffer')}
                                img={BlueHomeIcon.src}
                                btnClick={inspectionTypeSelected}
                                selected={
                                    selectedInspectionType ===
                                    EInspectionType.HOME
                                }
                            />
                            <InspectionButtonMobile
                                id={EInspectionType.WAREHOUSE}
                                header={t('InspectionAtSylndrHubMobile')}
                                subHeader={t('sellFormWinVoucher')}
                                img={SylndrS.src}
                                // tag={t('New') as string}
                                btnClick={inspectionTypeSelected}
                                selected={
                                    selectedInspectionType ===
                                    EInspectionType.WAREHOUSE
                                }
                                enableWave={
                                    !(
                                        selectedInspectionType ===
                                        EInspectionType.WAREHOUSE
                                    )
                                }
                            />
                        </div>
                    </section>
                )}
                {selectedInspectionType === EInspectionType.WAREHOUSE && (
                    <SylndrHubLocationButtonMobile
                        sylndrHubLocationButton={toggleDirectionModal}
                    />
                )}
                <section className={styles.items_flex_container}>
                    <Typography
                        variant="body1Medium"
                        className={styles.select_make}
                    >
                        {t('selectYourCarMake')}
                    </Typography>

                    <div className={styles.card_grid_container}>
                        {POPULAR_MAKES?.slice(0, 12)?.map(make => (
                            <button
                                key={make.id}
                                className={styles.card}
                                card-state={
                                    selectedMake?.id === make.id ? 'active' : ''
                                }
                                card-variant={
                                    make.id === 'All Makes' ? 'text' : ''
                                }
                                onClick={() => makeItemClicked(make)}
                            >
                                {make.id === 'All Makes' ? (
                                    <Typography
                                        style={{
                                            color: 'white',
                                            fontSize: '16px',
                                        }}
                                    >
                                        {t('all makes')}
                                    </Typography>
                                ) : (
                                    <Image
                                        width={60}
                                        height={60}
                                        src={make.image}
                                        alt={make.enName}
                                    />
                                )}
                            </button>
                        ))}
                    </div>
                </section>
            </section>
            <button
                onClick={() => popularMakeClicked()}
                className={`sylndr_button ${
                    selectedMake && selectedInspectionType
                        ? 'primary'
                        : 'disabled'
                } ${styles.button}`}
            >
                {t('continue')}
            </button>
            <SwipeableDrawer
                open={openDirectionModal}
                setOpen={setOpenDirectionModal}
            >
                <SylndrHubLocation closeModal={toggleDirectionModal} />
            </SwipeableDrawer>
        </div>
    );
};
export default SelectMakeCard;
